<template>
  <div class="pop-up-container">
    <DxPopup
      :visible="isVisible"
      :title="model.RecordId ? 'Edit Call Schedule' : 'Create Call Schedule'"
      :height="isTablet ? 450 : 400"
      :width="isTablet ? '80%' : '60%'"
      :wrapperAttr="{
        class: 'css-v2 gc-popup gc-popup-call-scheduler-call-log',
      }"
      :hide-on-outside-click="false"
      @shown="updateSettings()"
      @hidden="cancelCalendarSchedule()"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getFormItems"
          :formHeight="282"
          :isNormal="true"
          :data-model="model"
          :formMode="'create'"
          :validationGroup="'gc-popup-call-scheduler-call-log'"
          :formTitle="'gc-popup'"
          :ref="'bank-fee'"
          :setCustomizeItem="customizeItem"
        ></gc-form>
      </div>

      <div class="footer-buttons">
        <DxDropDownButton
          class="search-option margin-left-5 override-styles dx-button-success"
          :showArrowIcon="true"
          :stylingMode="'text'"
          :items="[
            { text: 'Update This Event Only', value: 'single' },
            { text: 'Update All Events in Series', value: 'all' },
          ]"
          keyExpr="value"
          displayExpr="text"
          :drop-down-options="{ width: 250 }"
          :onItemClick="onUpdateEvent"
          :useSelectMode="true"
          :text="'Update'"
          width="100%"
          v-if="!updateType"
          :disabled="!getPermissionToCreate"
        >
        </DxDropDownButton>
        <DxDropDownButton
          class="search-option override-styles dx-button-danger"
          :showArrowIcon="true"
          :stylingMode="'text'"
          :items="[
            { text: 'Delete This Event Only', value: 'single' },
            { text: 'Delete All Events in Series', value: 'all' },
          ]"
          keyExpr="value"
          displayExpr="text"
          :drop-down-options="{ width: 250 }"
          :onItemClick="onDeleteEvent"
          :useSelectMode="true"
          :text="'Delete'"
          width="100%"
          :disabled="false"
          v-if="!updateType"
        >
        </DxDropDownButton>
        <DxButton
          :text="getSaveButtonText"
          type="success"
          styling-mode="contained"
          class="button-full-width margin-left-5"
          @click="saveCalendarSchedule()"
          v-if="updateType"
        />
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          class="button-full-width margin-right-5"
          @click="cancelCalendarSchedule()"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import validationEngine from "devextreme/ui/validation_engine";
import { CustomerScheduleLogsService } from "../_services/api/customers/customer-schedule-logs.service";
import { CustomerCallLogsService } from "../_services/api/customers/customer-call-logs.service";
import { FeatureStorage } from "../_services/storage";
import { CacheService } from "../_services/cache/cache-service";
import { SalesRepresentativeService } from "../_services/api/sales/sales-rep.service";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: function () {},
    },
    displayValidationSummary: {
      type: Function,
      default: function () {},
    },
    showLoading: {
      type: Function,
      default: function () {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    isTablet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {
        CustomerCode: undefined,
        CustomerName: undefined,
        CallLogCallTypeCode: undefined,
        CallLogCallTypeDescription: undefined,
        PlannedDate: undefined,
        PlannedTime: undefined,
        Duration: undefined,
        CallScheduleFrequency: undefined,
        repeatDaily: "Everyday",
        EndDate: undefined,
        CallPurpose: undefined,
        RecordId: undefined,
        Reoccurence: 1,
      },
      formMode: "review",
      updateType: undefined,
      CustomerSalesRepresentativeCode: undefined,
    };
  },
  created() {
    if (this.isTablet == true) this.setDefaultCustomerRep();
    document.addEventListener("keydown", this.escHandler);
    if (this.dataModel) {
      if (this.dataModel.RecordId) {
        this.model.RecordId = this.dataModel.RecordId;
        this.model.CustomerCode = this.dataModel.GcorpReference;
        this.model.CallLogCallTypeCode = this.dataModel.ScheduleType;
        // this.model.CallLogCallTypeDescription = this.dataModel.ScheduleType;
        this.model.PlannedDate = this.dataModel.StartDate
          ? this.dataModel.StartDate
          : undefined;
        this.model.PlannedTime = this.model.PlannedDate;
        this.model.Duration = this.dataModel.ExpectedDuration;
        this.model.CallScheduleFrequency =
          this.dataModel.Frequency.charAt(0).toUpperCase() +
          this.dataModel.Frequency.slice(1);
        this.model.EndDate = this.dataModel.EndDate
          ? new Date(this.dataModel.EndDate)
          : undefined;
        this.model.CallPurpose = this.dataModel.Purpose;
        this.model.Reoccurence = this.dataModel.Reoccurence;
      } else {
        this.model.CallScheduleFrequency = "Once";
        this.model.EndDate = this.dataModel.StartDate;
        this.updateType = "create";
        this.formMode = "create";
      }

      this.model.PlannedDate = this.dataModel.StartDate;
      this.model.PlannedTime = this.dataModel.StartDate;
    } else {
      this.model.CallScheduleFrequency = "Once";
      this.updateType = "create";
      this.formMode = "create";
    }
  },
  destroyed() {
    document.removeEventListener("keydown", this.escHandler);
  },
  methods: {
    customizeItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};

        item.editorOptions.disabled =
          this.getFormMode != "review" ? false : true;
        if (item.editorOptions.allowUpdate == false)
          item.editorOptions.disabled = true;
        if (item.editorOptions.allowUpdate == true)
          item.editorOptions.disabled = false;
        if (item.editorOptions.readOnly) item.editorOptions.readOnly = true;
      }
    },
    escHandler(e) {
      setTimeout(() => {
        if (e.code == "Escape") {
          this.cancelBankFeeEdit();
        }
      }, 100);
    },
    updateSettings() {},
    cancelCalendarSchedule() {
      this.callback(false);
    },
    async onUpdateEvent(e) {
      this.updateType = e.itemData.value;
      this.formMode = "edit";

      if (this.updateType == "single") {
        this.showLoading(true);
        await CustomerCallLogsService.getByCustomerCallLogHeader(
          this.dataModel.CallLogRecordId
        )
          .then(async (res) => {
            if (res.data.value.length > 0) {
              var data = res.data.value[0];

              this.model.RecordId = data.RecordId;
              this.model.CalendarScheduleRecordID =
                data.CalendarScheduleRecordID;
              this.model.CustomerCode = data.CustomerCode;
              this.model.CallLogCallTypeCode = data.CallLogCallTypeCode;
              this.model.PlannedDate = new Date(data.PlannedDate);
              this.model.PlannedTime = new Date(data.PlannedDate);
              this.model.Duration = data.ExpectedDuration;
              this.model.CallScheduleFrequency = "Once";
              this.model.EndDate = new Date(
                data.PlannedDate
              ).toSaveDateEndTime();
              this.model.CallPurpose = data.CallPurpose;
              this.model.Reoccurence = 1;
            }
            this.showLoading(false);
          })
          .catch((err) => {
            if (err) this.showLoading(false);
          });
      }
    },
    async onDeleteEvent(e) {
      // eslint-disable-next-line
      console.log("onDeleteEvent ", e);
      let deleteType = e.itemData.value;

      let confirmDelete = await this.$confirm(
        `Are you sure you want to delete ${
          deleteType == "single" ? "this event" : "the event series"
        }?`,
        `Delete  ${deleteType == "single" ? "Event" : "Event Series"}`
      );
      if (confirmDelete) {
        if (deleteType == "single") {
          this.showLoading(true);
          await CustomerScheduleLogsService.deleteSingleEvent(
            this.dataModel.CallLogRecordId
          )
            .then(async (res) => {
              if (res) this.showLoading(false);
              this.callback(true);
            })
            .catch((err) => {
              if (err) this.showLoading(false);
            });
        }
        if (deleteType == "all") {
          this.showLoading(true);
          await CustomerScheduleLogsService.deleteEventSeriesForCallLog(
            this.dataModel.CallLogRecordId
          )
            .then(async (res) => {
              if (res) this.showLoading(false);
              this.callback(true);
            })
            .catch((err) => {
              if (err) this.showLoading(false);
            });
        }
      }
    },
    async saveCalendarSchedule() {
      let timezoneInfo = Intl.DateTimeFormat().resolvedOptions().timeZone;

      let headerform = await validationEngine.validateGroup(
        "gc-popup-call-scheduler-call-log"
      );

      if (!headerform.isValid)
        this.displayValidationSummary(headerform.brokenRules);
      else {
        var model = { ...this.model };

        if (this.updateType == "single") {
          // update single event
          let payload = {
            CalendarScheduleRecordID: this.model.RecordId
              ? this.model.RecordId
              : "00000000-0000-0000-0000-000000000000",
            CallLogCallTypeCode: model.CallLogCallTypeCode,
            CallPurpose: model.CallPurpose,
            CustomerCode: model.CustomerCode,
            ExpectedDuration: model.Duration,
            ActualDuration: 0,
            PlannedDate: new Date(model.PlannedDate),
            RecordId: this.model.RecordId
              ? this.model.RecordId
              : "00000000-0000-0000-0000-000000000000",
            Status: "O",
          };

          await CustomerScheduleLogsService.saveCustomerCallLogSingleEvent(
            payload
          )
            .then((res) => {
              if (res) this.showLoading(false);
              this.callback(true);
            })
            .catch((err) => {
              // console.log("saveCustomerCallLog err", err);
              this.showLoading(false);

              this.displayServerError(err, "Save Failed");
            });
        } else {
          let payload = {
            EndDate: new Date(model.EndDate.toSaveDateEndTime()),
            ExpectedDuration: model.Duration,
            Frequency: model.CallScheduleFrequency.toLowerCase(),
            TimeZone: timezoneInfo,
            GcorpObject: model.CustomerName,
            GcorpReference: model.CustomerCode,
            Purpose: model.CallPurpose,
            RecordId: this.model.RecordId
              ? this.model.RecordId
              : "00000000-0000-0000-0000-000000000000",
            Reoccurence: this.model.Reoccurence,
            ScheduleType: model.CallLogCallTypeCode,
            StartDate: new Date(model.PlannedDate),
            PlannedTime: new Date(model.PlannedDate),
            CalendarScheduleFrequencies: [],
          };

          if (model.CallScheduleFrequency.toLowerCase() == "daily") {
            payload.CalendarScheduleFrequencies.push({
              CalendarScheduleRecordID: this.model.RecordId
                ? this.model.RecordId
                : "00000000-0000-0000-0000-000000000000",
              // RecordId: "00000000-0000-0000-0000-000000000000",
              Frequency:
                model.repeatDaily.toLowerCase() == "everyday"
                  ? model.repeatDaily.toLowerCase()
                  : "weekday",
              Reoccurence: this.model.Reoccurence,
            });
          } else if (model.CallScheduleFrequency.toLowerCase() == "weekly") {
            payload.CalendarScheduleFrequencies.push({
              Frequency: new Date(model.PlannedDate)
                .toLocaleString("en-us", {
                  weekday: "long",
                })
                .toLowerCase(),
              Reoccurence: 1,
            });
          } else {
            payload.CalendarScheduleFrequencies.push({
              Frequency: new Date(model.PlannedDate).getDate().toString(),
              Reoccurence: 1,
            });
          }

          this.showLoading(true);

          await CustomerScheduleLogsService.saveCustomerCallLog(payload)
            .then((res) => {
              if (res) this.showLoading(false);
              this.callback(true);
            })
            .catch((err) => {
              // console.log("saveCustomerCallLog err", err);
              this.showLoading(false);

              this.displayServerError(err, "Save Failed");
            });
        }
      }
    },
    onCustomerValueChanged(e) {
      if (e.name == "selectedItem") {
        this.model.CustomerName = e.value.Name;
      }
    },
    onCallTypeChanged(e) {
      if (e.selectedItem)
        this.model.CallLogCallTypeDescription = e.selectedItem.Description;
    },
    gotoCallLogRecord() {
      let baseUrl = process.env.VUE_APP_BASE_URL;
      let navigateToUrl = "";

      if (baseUrl === "/")
        navigateToUrl = `${baseUrl}call-logs/edit/${this.dataModel.CallLogRecordId}`;
      else
        navigateToUrl = `/${baseUrl}/call-logs/edit/${this.dataModel.CallLogRecordId}`;

      window.open(navigateToUrl, "_blank");
    },
    onCallScheduleFrequencyValueChanged(e) {
      if (e.event && e.previousValue == "Once") this.model.EndDate = undefined;

      if (e.event && e.value == "Once")
        this.model.EndDate = this.model.PlannedDate;
      else {
        this.model.EndDate = new Date(
          new Date(this.model.PlannedDate).setFullYear(new Date(this.model.PlannedDate).getFullYear() + 1)
        );
      }
    },
    onStartCallValueChanged(e) {
      if (e.event && this.model.CallScheduleFrequency == "Once")
        this.model.EndDate = e.value;
    },
    async setDefaultCustomerRep() {
      var defaultSalesRep = CacheService.getCache(
        "UserDefaultSalesRepresentative"
      );

      if (!defaultSalesRep) {
        await SalesRepresentativeService.getUserDefaultSalesRepresentative()
          .then((result) => {
            this.setLoading = false;
            if (result.data.value[0].SalesRepresentativeCode != "") {
              this.CustomerSalesRepresentativeCode =
                result.data.value[0].SalesRepresentativeCode;
            }

            CacheService.saveCache(
              "UserDefaultSalesRepresentative",
              result.data.value[0],
              2
            );
          })
          .catch((err) => {
            if (err) {
              this.setLoading = false;
            }
          });
      } else {
        if (defaultSalesRep.SalesRepresentativeCode != "")
          this.CustomerSalesRepresentativeCode =
            defaultSalesRep.SalesRepresentativeCode;
      }
    },
  },
  computed: {
    getCustomerRepDefault() {
      if (this.CustomerSalesRepresentativeCode)
        return this.CustomerSalesRepresentativeCode;
      else return false;
    },
    getPermissionToCreate() {
      return FeatureStorage.checkPermission("CallSchedules", "create");
    },
    getFormMode() {
      return this.formMode;
    },
    getSaveButtonText() {
      if (this.model.RecordId) return "Update";
      else return "Save";
    },
    isVisible() {
      return this.visible;
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Customer",
                  dataField: "CustomerCode",
                  required: true,
                  editorOptions: {
                    onOptionChanged: this.onCustomerValueChanged,
                    select: ["Code", "Name", "Inactive"],
                  },
                  touchEnabled: this.isTablet,
                  touchModalOptions: {
                    salesrep: true,
                    getUserDefaultRep: this.getCustomerRepDefault,
                  },
                },
                {
                  screenField: "CallType",
                  label: {
                    text: "Type",
                  },
                  dataField: "CallLogCallTypeCode",
                  required: true,
                  editorOptions: {
                    select: ["Code", "Description", "Inactive"],
                    onSelectionChanged: this.onCallTypeChanged,
                  },
                  touchEnabled: this.isTablet,
                },
                {
                  // screenField: "DateIn",
                  dataField: "PlannedDate",
                  editorType: "dxDateBox",
                  // touchEnabled: this.isTablet,
                  label: {
                    text: "Date",
                  },
                  required: true,
                  editorOptions: {
                    // pickerType: "calendar",
                    type: "date",
                    displayFormat: "dd MMM yyyy",
                  },
                },
                {
                  label: {
                    text: "Planned Time",
                  },
                  // touchEnabled: this.isTablet,
                  dataField: "PlannedDate",
                  required: true,
                  editorType: "dxDateBox",
                  editorOptions: {
                    // pickerType: "calendar",
                    type: "time",
                    displayFormat: "hh:mm a",
                    onValueChanged: this.onStartCallValueChanged,
                  },
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  cssClass: "duration-group",
                  items: [
                    {
                      label: {
                        text: "Duration",
                      },
                      dataField: "Duration",
                      editorType: "dxNumberBox",
                      required: true,
                      editorOptions: {
                        // readOnly: true,
                      },
                    },
                    {
                      label: {
                        text: "Min(s)",
                      },
                      editorType: "dxTextBox",
                      cssClass: "duration-Mins",
                      editorOptions: {
                        readOnly: true,
                      },
                    },
                  ],
                },
                {
                  screenField: "CallScheduleFrequency",
                  dataField: "CallScheduleFrequency",
                  editorOptions: {
                    onValueChanged: (e) => {
                      this.onCallScheduleFrequencyValueChanged(e);
                    },
                    readOnly:
                      this.updateType == "single" && this.formMode == "edit",
                  },
                  visible: this.updateType != "single",
                  touchEnabled: this.isTablet,
                  editorTemplate: this.isTablet
                    ? {
                        primary: [
                          {
                            dataField: "value",
                          },
                        ],
                      }
                    : undefined,
                },
                {
                  dataField: "repeatDaily",
                  visible:
                    this.model.CallScheduleFrequency == "Daily" &&
                    this.updateType != "single",
                  label: {
                    text: "Repeat",
                    // visible: false,
                  },
                  cssClass: "radio-group",
                  editorType: "dxRadioGroup",
                  editorOptions: {
                    layout: "horizontal",
                    items: [
                      {
                        value: "Everyday",
                      },
                      {
                        value: "Every Weekday",
                      },
                    ],
                    valueExpr: "value",
                    displayExpr: "value",
                  },
                },
                {
                  screenField: "DateIn",
                  dataField: "EndDate",
                  label: {
                    text: "End Date",
                  },
                  editorType: "dxDateBox",
                  required: true,
                  visible:
                    this.model.CallScheduleFrequency != "Once" &&
                    this.updateType != "single",
                  editorOptions: {
                    min: this.model.PlannedDate,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  label: {
                    text: "Purpose",
                  },
                  dataField: "CallPurpose",
                  editorType: "dxTextArea",
                  cssClass: "CallPurpose",
                  editorOptions: {
                    tabIndex: 5,
                    height: 238,
                  },
                },
                {
                  dataField: "",
                  label: {
                    text: " ",
                  },
                  cssClass: "generate-btn",
                  editorType: "dxButton",
                  visible: this.model.RecordId ? true : false,
                  editorOptions: {
                    allowUpdate: FeatureStorage.checkPermission(
                      "CallLogs",
                      "create"
                    ),
                    onClick: async () => {
                      this.gotoCallLogRecord();
                    },
                    text: "Call Log",
                    type: "default",
                    rtlEnabled: true,
                    // useSubmitBehavior: true,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.footer-buttons {
  display: flex;
  align-content: center;
  justify-content: center;
  gap: 0.2em;
}

.button-full-width {
  width: 100%;
}

.margin-right-5 {
  margin-right: 10px;
}

.margin-left-5 {
  margin-left: 10px;
}

.gc-popup-call-scheduler-call-log {
  div.dx-popup-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .duration-group {
      .dx-item.dx-box-item:nth-child(2) {
        align-items: center;
        flex: unset !important;
        .duration-Mins {
          justify-content: flex-end;
          padding: 0;
          .dx-field-item-content {
            display: none;
          }
        }
      }
    }

    .CallPurpose {
      > label {
        padding-top: 6px;
      }

      textarea {
        padding-top: 1px !important;
      }
    }

    .radio-group {
      div.dx-field-item-content {
        div.dx-item-content {
          font-size: 12px;
        }
      }
    }

    .footer-buttons {
      padding-bottom: 10px;
    }
  }
}
</style>
